import { defineStore } from "pinia";

export const useDirtyStore = defineStore("dirty", {
    state: () => ({
        isDirty: false,
    }),
});
